import React from "react";
import { useNavigate } from "react-router-dom";
import "./Books.css";

const books = [
  {
    title: "Class 11 book - Comprehensive Questions",
    pdfUrl: "path/to/class12.pdf",
    price: 99,
  },
  {
    title: "Class 12 book - Comprehensive Questions",
    pdfUrl: "path/to/class12.pdf",
    price: 99,
  },
];

const Books = () => {
  const navigate = useNavigate();

  const handleBuyNow = (pdfUrl) => {
    alert("Payment is not integrated yet. Please try again later.");
  };

  const handleContactUs = () => {
    navigate("/contact");
  };

  return (
    <div className="books-container">
      <h1 className="books-title">Our Books</h1>
      <div className="books">
        {books.map((book, index) => (
          <div className="book" key={index}>
            <h2 className="book-title">{book.title}</h2>
            <p className="book-price">Price: ₹{book.price}</p>
            <button
              className="buy-button"
              onClick={() => handleBuyNow(book.pdfUrl)}
            >
              Buy Now
            </button>
          </div>
        ))}
      </div>
      <div className="payment-notice">
        Payment integration is not available yet. Please try again later.
      </div>
      <div className="contact-info">
        <p>
          If you want the books now, please{" "}
          <span onClick={handleContactUs} className="contact-link">
            contact us
          </span>
          .
        </p>
      </div>
    </div>
  );
};

export default Books;
